import { Flex, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

import { InvoicingSettingsLoadErrorMessage } from '../../../../../../elements/InvoicingSettingsLoadErrorMessage'
import { AutomaticPaymentReminders } from '../AutomaticPaymentReminders'
import { PaymentMethodsSettingsFields } from '../PaymentMethodsSettingsFields'
import { PaymentsAndRemindersSettingsFormFieldsSkeletons } from './elements/PaymentsAndRemindersSettingsFormFieldsSkeletons'

interface PaymentsAndRemindersSettingsFormFieldsProps {
  hasFailedToLoad: boolean
  isLoading: boolean
  onRetry: () => Promise<unknown>
}

// The fields stay hidden until both queries have succeeded. Showing them on a failed fetch would
// let an edit mark the form dirty, skip hydration, and save the empty defaults over stored settings.
export const PaymentsAndRemindersSettingsFormFields = ({
  hasFailedToLoad,
  isLoading,
  onRetry,
}: PaymentsAndRemindersSettingsFormFieldsProps): ReactElement => {
  if (isLoading) {
    return <PaymentsAndRemindersSettingsFormFieldsSkeletons />
  }

  if (hasFailedToLoad) {
    return <InvoicingSettingsLoadErrorMessage onRetry={onRetry} />
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S24}>
      <PaymentMethodsSettingsFields />
      <AutomaticPaymentReminders />
    </Flex>
  )
}
